import { DRESS_CODE_NOTE, SCHEDULE } from "../data/content";

export function Schedule() {
  return (
    <section id="schedule" className="section schedule">
      <div
        className="schedule__ornament"
        data-par="0.4"
        aria-hidden="true"
        style={{ right: -170, top: 40, width: 300, height: 300, opacity: 0.1 }}
      />
      <div
        className="schedule__ornament"
        data-par="0.55"
        aria-hidden="true"
        style={{ left: -150, bottom: -90, width: 220, height: 220, opacity: 0.28 }}
      />

      <div className="container container--1080 schedule__inner">
        <div className="section-head">
          <p className="eyebrow eyebrow--light">Schedule</p>
          <h2 className="h2 h2--tight">Three days in Loudoun</h2>
        </div>
        <p className="body schedule__intro">
          Everything happens within fifteen minutes of the winery. Come for the whole weekend if
          you can.
        </p>

        <div className="grid grid--gap24 auto-300 schedule__cards">
          {SCHEDULE.map((event) => (
            <article className="card card--paper schedule__card" key={event.name}>
              <p className="eyebrow">{event.day}</p>
              <h3 className="h3">{event.name}</h3>
              <p className="card-time">{event.when}</p>
              <p className="body">{event.where}</p>
              <p className="body schedule__detail" style={{ color: "var(--muted)" }}>
                {event.detail}
              </p>
              <a
                className="btn btn--outline"
                href={event.directions}
                target="_blank"
                rel="noreferrer"
              >
                Get directions
                <span className="visually-hidden"> to {event.name}</span>
              </a>
            </article>
          ))}
        </div>

        <p className="fine schedule__note">{DRESS_CODE_NOTE}</p>
      </div>
    </section>
  );
}
